import { render } from "./tep-ks-tarif-norm-view.vue?vue&type=template&id=724fa392"
import script from "./tep-ks-tarif-norm-view.vue?vue&type=script&setup=true&lang=js"
export * from "./tep-ks-tarif-norm-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/tep/tep-nsi/tep-ks-tarif-norm-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "724fa392"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('724fa392', __exports__)) {
    api.reload('724fa392', __exports__)
  }
  
  module.hot.accept("./tep-ks-tarif-norm-view.vue?vue&type=template&id=724fa392", () => {
    api.rerender('724fa392', render)
  })

}


export default __exports__